module.exports = __webpack_public_path__ + "static/media/Shabnam-Thin.361ec45d.eot";